import { useQuery } from '@tanstack/react-query';

import { DreGrupo } from '../types';

import { useRequestListagem } from 'hooks/useRequestListagem';

export function useQueryGrupos() {
    const requestListagem = useRequestListagem();

    return useQuery<DreGrupo[]>(['queryGrupos'], () =>
        requestListagem({
            url: '/dre/tipodremercadologicagrupoexibicao/telaconfiguracao',
            sort: [{ direction: 'ASC', property: 'idDreMercadologicaTipoGrupoExibicao' }],
            nested: true,
        }).then((res) => res.data.data),
    );
}
